import React from "react";
import { renderVenuesActions, renderVenueSelectionHeader, renderVenueSelectionCell } from "./customRenderers";
import { renderEditableInput, renderEditableBoolean } from "../../../constants/reactUtilities";
import FilterUtility from "../../common/FilterUtility";
export const venuesDataColumns = (
  onChangeMethod,
  isEditable,
  deleteVenue,
  selectedVenueIds,
  toggleVenueSelection,
  toggleAllVenueSelection,
  allVisibleSelected
) => {
  return [
    {
      Header: renderVenueSelectionHeader(allVisibleSelected, toggleAllVenueSelection),
      id: "selection",
      accessor: "id",
      filterable: false,
      sortable: false,
      maxWidth: 56,
      Cell: ({ original }) =>
        renderVenueSelectionCell(
          selectedVenueIds.includes(String(original.id)),
          () => toggleVenueSelection(original),
          !!original.isDeleting
        ),
      style: { textAlign: "center" }
    },
    {
      Header: "Venue",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "venues.data.$.", "name", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Actual Name",
      id: "actual_name",
      accessor: "actual_name",
      Cell: renderEditableInput.bind(this, "venues.data.$.", "actual_name", isEditable, onChangeMethod, "text"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Score",
      id: "score",
      accessor: "score",
      Cell: renderEditableInput.bind(this, "venues.data.$.", "score", isEditable, onChangeMethod, "number"),
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="number" />
    },
    {
      Header: "Efficiency Factor",
      id: "efficiency_enabled",
      accessor: "efficiency_enabled",
      Cell: renderEditableBoolean.bind(this, "venues.data.$.", "efficiency_enabled", isEditable, onChangeMethod),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderVenuesActions.bind(this, deleteVenue),
      style: { textAlign: "center" }
    }
  ];
};
export const venueModalDataColumns = (onChangeMethod, deleteVenue) => {
  return [
    {
      Header: "Venue",
      id: "name",
      accessor: "name",
      Cell: renderEditableInput.bind(this, "newVenues.$.", "name", true, onChangeMethod, "text"),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Actual Name",
      id: "actual_name",
      accessor: "actual_name",
      Cell: renderEditableInput.bind(this, "newVenues.$.", "actual_name", true, onChangeMethod, "text"),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Score",
      id: "score",
      accessor: "score",
      Cell: renderEditableInput.bind(this, "newVenues.$.", "score", true, onChangeMethod, "number"),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Efficiency Factor",
      id: "efficiency_enabled",
      accessor: "efficiency_enabled",
      Cell: renderEditableBoolean.bind(this, "newVenues.$.", "efficiency_enabled", true, onChangeMethod),
      style: { textAlign: "center" },
      filterable: false
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderVenuesActions.bind(this, deleteVenue),
      style: { textAlign: "center" }
    }
  ];
};
